<template>
  <div class="card_flex">
    <div class="filter">
      <div class="input_wrap">
        <fg-input
            v-model="searchword"
            type="text"
            class=""
            :label="translate('group.search')"
            placeholder="name group"
            @keyup.enter="search"
        />
        <span v-if="searchword.length > 0" class="mdi mdi-close clear" @click="clear_search"/>
      </div>

      <button
        class="btn btn-success"
        @click="search"
      >
        {{ translate('search') }}
      </button>
    </div>
    <div class="group_list device_groups">
      <v-tree style="margin-top: 10px; margin-left: 30px" ref='tree1' @drag-node-end="drag" :canDeleteRoot="true" :data='groupTree' :draggable='true'  :tpl='tpl' />
    </div>
  </div>
</template>

<script>
//  import SisSelectThead from 'components/UIComponents/Inputs/SisSelectThead.vue'
import VTree from "vue-tree-halower";
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm";

export default {
  name: 'Groups',
  components: {
    // SisSelectThead
    VTree
  },
  data () {
    return {
      new_group: {},
      searchword: '',
      search_group: [],
      cur_group: null
    }
  },
  computed: {
    groups () {
      return this.$store.getters.getDeviceGroups
    },
    groupTree () {
      return  [{
        expanded: true,
        id: -1,
        label: 'all group',
        name: 'all group',
        children: this.$store.getters.getDeviceGroupsTree
      }]
    }
  },

  watch: {
    groups(){
      if (this.cur_group && this.cur_group.id) {
        this.choice(this.$store.getters.getDeviceGroupById(this.cur_group.id))
      }
    },
    groupTree () {
      if(this.new_group.id !== undefined) {
        this.$refs.tree1.searchNodes((node) => {
          if (node.id === this.new_group.id) {
            this.choice(node)
            node.searched = true
            this.new_group = {}
          }
        })
      }
    }
  },
  methods: {
    clear_search(){
      this.searchword = ''
      this.search()
    },
    search () {
      if(this.searchword.trim() === '') {
        this.$refs.tree1.searchNodes()
      }
      let searched = []
      this.$refs.tree1.searchNodes((node) => {
        let name = node.name.toLowerCase()
        if (name.indexOf(this.searchword.toLowerCase()) !== -1){
          searched.push(node)
        }
        return name.indexOf(this.searchword.toLowerCase()) !== -1
      })
      if (!searched.length){
        this.global_notify('danger', this.translate('search_nothing'))
      }
    },
    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      let cross = (parent !== null && this.$store.getters.getPermissions.editDeviceGroups === true) ? <span class="mdi mdi-close-box red" onClick={() => this.delete_confirm(node, parent, index)} title="delete"/> : ''

      let add = this.$store.getters.getPermissions.editDeviceGroups === true ?
          <button
            className="treebtn1"
            onClick={() => this.addDeviceGroup(node)}
          >
            +
          </button>
          : ''


      return <span class="tree_element">

        {add}

        <span class={titleClass} domPropsInnerHTML={node.name} onClick={() => {
          if(parent == null) {
            this.clear()
            return false
          }
          this.$refs.tree1.nodeSelected(node);
          this.choice(node)
        }}>

        </span>
        {cross}
      </span>
    },
    drag (...args) {
      let {dragNode: dragNode, targetNode: target} = args[0]
      this.$http.v1.updateGroup({'id': dragNode.id, 'name': dragNode.name, 'parent': target.id}, () => {
        this.global_notify('info', this.translate('group.updated'))
        this.$store.dispatch('deviceGroupUpdate')
      }, () => {
        this.$store.dispatch('deviceGroupUpdate')
      })
    },
    choice (group) {
      this.cur_group = group
      this.$emit('choice', group)
    },
    clear(){
      this.choice({})
    },

    delete_confirm (node) {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('group.del') + ' ' + node.name +'?'
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          },
          confirm: () => {
            this.deleteDeviceGroup(node)
            this.$modal.hide('dynamic-modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'dynamic-modal'})

    },

    deleteDeviceGroup (node) {
      this.$http.v1.deleteDeviceGroup({'id': node.id}, () => {
        this.global_notify('info', this.translate('group.deleted'))
        if (this.cur_group.id === node.id){
          this.clear()
        }
        this.$store.dispatch('deviceGroupUpdate')
      }, (bad_answer) => {
        this.bad_answer_handler(bad_answer)
        this.$store.dispatch('deviceGroupUpdate')
      })
    },
    addDeviceGroup (node) {
      this.$http.v1.addDeviceGroup({'name': "!new group", 'parent': node.id }, (resp) => {
        this.global_notify('info', this.translate('group.added'))
        this.$store.dispatch('deviceGroupUpdate');
        this.new_group = resp.data
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.card_flex {
  overflow: hidden;
  padding: 10px;
  .filter {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 10px;
    .input_wrap{
      position: relative;
      width: 80%;
      .form-group{
        margin-bottom: 0;
      }
      .clear{
        position: absolute;
        right: 0;
        bottom: 0;
        height: 40px;
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #66615b;
        font-weight: bold;
        cursor: pointer;
        &:hover{
          color: #e53935;
        }
      }
    }

    .btn{
      width: 15%;
      padding: 7px;
      height: 40px;
    }
  }
  .group_list {
    overflow: auto;
    width: 100%;
    flex: 12;
    border: 1px solid #DCDCDC;
  }
}

@media (max-width: 768px) {
  .card_flex {
    padding: 10px 0;
    .filter {
      .form-group{
        width: 70%;
        margin-right: 10px;
      }
      .btn{
        width: 30%;
      }
    }
    .group_list {
      overflow: auto;
      width: 100%;
      flex: 12;
      border: 1px solid #DCDCDC;
    }
  }
}
</style>
